"use strict";
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
/* Collection of status objects to properly type json objects */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createError = createError;
exports.createOk = createOk;
exports.isStatusError = isStatusError;
exports.isStatusOk = isStatusOk;
exports.unwrap = unwrap;
// Function to easy creation of status objects
function createError(error) {
    return { status: 'error', error: error };
}
function createOk(result) {
    return { status: 'ok', result: result };
}
// Type guards
function isStatusError(status) {
    return status.status === 'error';
}
function isStatusOk(status) {
    return status.status === 'ok';
}
// Losely inspired by Rust
function unwrap(status) {
    if (isStatusOk(status)) {
        return status.result;
    }
    else if (isStatusError(status)) {
        throw status.error;
    }
    else {
        // We did not receive a Status object
        throw 'Invalid Status object';
    }
}
//# sourceMappingURL=Status.js.map